<template>
    <div id="pagination" class="paging" v-if="data != null && data !== undefined">
        <ul class="pagination">
            <li><a :href="getPrevUrl()" v-show="getPrevUrl() !== null"><<</a></li>
            <li :class="{ 'active': page.selected }" v-for="page in pages">
                <a :href="getUrl(page.id)">{{page.id}}</a>
            </li>
            <li><a :href="getNextUrl()"  v-show="getNextUrl() !== null">»</a></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Pagination',
        props: ['data'],
        data() {
            return {
                pagination: this.data == null ? {} : this.data,
                pages: [],
            }
        },
        methods: {
            setPages() {
                this.pages = [];
                let max_page = 10;
                let first_page = 1;
                let last_page = this.pagination.last_page;
                let current_page = this.getCurrentPageID();
                let pad = 4;

                if(last_page > max_page) {
                    if(current_page > max_page) {
                        first_page = (current_page - pad) < 1 ? 1 : (current_page - pad);
                        last_page = current_page + pad;
                    } else {
                        first_page = 1;
                        last_page = max_page;
                    }
                }

                for (let i = first_page; i <= last_page; i++) {
                    this.pages.push({
                        id: i,
                        selected: this.isCurrentPage(i),
                    });
                }
            },
            getPrevUrl() {
                return this.getUrl(this.getCurrentPageID() > 1  ? (this.getCurrentPageID() -1) : null);
            },
            getUrl(pageID) {

                if(pageID !== null) {
                    return this.$route.path + '?page=' + pageID;
                }

                return null;
            },
            getNextUrl() {
                return this.getUrl((this.getCurrentPageID() + 1) <= this.pagination.last_page ? (this.getCurrentPageID() + 1) : null);
            },
            getCurrentPageID() {
                return parseInt(this.$route.query.page  ? this.$route.query.page : 1);
            },
            isCurrentPage(pageID) {
                let queryPageID = this.getCurrentPageID();

                if(queryPageID === undefined && pageID == 1) {
                    return true;
                } else if(pageID == queryPageID){
                    return true;
                } else {
                    return false;
                }
            }
        },
        mounted() {
            this.setPages();
        },
        watch: {
            data: function(newVal) {
                this.pagination = newVal;
                this.setPages();
            },

        }
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    #pagination {
        position: relative;
        margin-top: 20px;

        .pagination {
            margin: 0;

            .active>a, .active>a:hover, li>a:hover {
                color: #fff;
                background: #ec0000;
                border: 1px solid transparent;
            }

            li a {
                border-radius: 0 !important;
                margin-right: 8px;
                color: #7c7c7c;
                border: 1px solid #ddd;
                position: relative;
                float: left;
                padding: 6px 12px;
            }

            .page-numbers {
                border: 0;
                color: #7c7c7c;
                position: absolute;
                right: 0;
                top: 3px;
            }
        }
    }
</style>